<template>
  <div class="navbar" v-if=" ! isHome">
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" @isHome="isHomeHander"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'

export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      isHome: false
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ])
  },
  methods: {
    isHomeHander(isHome) {
      this.isHome = isHome
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 20px;
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 900;
}

.app-breadcrumb.el-breadcrumb{
    line-height: 20px;
}
</style>
